import React from 'react';
import styled from 'styled-components';
import { Row, Column } from 'react-foundation';
import { Meter } from '../../components/Meter';
import { Icon } from '../../components/Icon';

interface Props {
	usageData: any;
	renderAdditionalInfo: boolean;
};

const Wrapper = styled(Row)`
  margin-bottom: 3rem;
`;
Wrapper.defaultProps = {};

const Indicator = styled(Column)`
  text-align: center;
`;

const Info = styled.div`
  font-size: 20 px;
  margin: auto;
  text-align: center;
`;

const Costs = styled.div`
  text-align: center;
  margin: auto;
  max-width: 25rem;
`;

const BorderContainer = styled.div`
  border-top: 1px solid grey;
  width: 60%;
  min-width: 10rem;
  height: auto;
  margin: 0 auto;
  position: relative;
`;

const ExpensesContainer = styled.div`
  width: 70%;
  min-width: 10rem;
  height: auto;
  margin: 0 auto;
  position: relative;
`;

const AdditionalExpensesRow = styled.div<{firstItem?: boolean}>`
  padding: 0.3em 0 0.3em 0;
  border-bottom: 1px solid #eaeaea;
  text-align: left;
  border-top: ${(props) => props.firstItem ? '1px solid #eaeaea' : ''};
  .value {
    float: right;
  }
`;

Indicator.defaultProps = {
	small: 12,
	medium: 4,
};

export const SimUsage: React.FC<Props> = (props: Props) => {
	return (
		<Wrapper>
			{!props.renderAdditionalInfo && (
				<div>
					<Indicator>
						<Info>
							<Icon name="medium--data" />
							<Meter
								quantity={props.usageData.data !== null ? props.usageData.data : null}
								unit="Gt"
								description="Datan kulutus"
							/>
						</Info>
					</Indicator>
					<Indicator>
						<Info>
							<Icon name="medium--chat" />
							<Meter
								quantity={props.usageData.message !== null ? props.usageData.message : null}
								unit="kpl"
								description="Tekstiviestejä"
							/>
						</Info>
					</Indicator>
					<Indicator>
						<Info>
							<Icon name="medium--smile" />
							<Meter
								quantity={props.usageData.voice !== null ? props.usageData.voice : null}
								unit="min"
								description="Puheluminuutteja"
							/>
						</Info>
					</Indicator>
					<Indicator>
						<Costs>
							<BorderContainer>
								<p>Roamingmaksut {props.usageData.roamingEuros} €</p>
							</BorderContainer>
						</Costs>
					</Indicator>
					<Indicator>
						<Costs>
							<BorderContainer>
								<p>Palvelumaksut {props.usageData.serviceEuros} €</p>
							</BorderContainer>
						</Costs>
					</Indicator>
				</div>
			)}
			{props.renderAdditionalInfo && (
				<div>
					<Indicator>
						<Info>
							<Icon name="medium--data" />
							<Meter
								quantity={props.usageData.data !== null ? props.usageData.data : null}
								unit="Gt"
								description="Datan kulutus"
							/>
						</Info>
					</Indicator>
					<Indicator>
						<Info>
							<Icon name="medium--chat" />
							<Meter
								quantity={props.usageData.mois !== null ? props.usageData.mois : null}
								unit="€"
								description="Puhelujen ja viestien maksut"
							/>
						</Info>
					</Indicator>
					<Indicator>
						<Info>
							<Icon name="medium--smile" />
							<Meter
								quantity={props.usageData.additionalServicesTotal !== null ? props.usageData.additionalServicesTotal : null}
								unit="€"
								description="Lisämaksullisia palveluja käytetty"
							/>
						</Info>
					</Indicator>
					<Indicator>
						<Costs>
							<ExpensesContainer>
								<AdditionalExpensesRow firstItem>Palvelupuhelut <span className={'value'}>{props.usageData.vasCallsTotal} € </span></AdditionalExpensesRow>
								<AdditionalExpensesRow>Palveluviestit <span className={'value'}>{props.usageData.vasMsgTotal} €</span></AdditionalExpensesRow>
								<AdditionalExpensesRow>Sovellusostot <span className={'value'}>{props.usageData.vasAppTotal} €</span></AdditionalExpensesRow>
								<AdditionalExpensesRow>Roaming-maksut ulkomailla <span className={'value'}>{props.usageData.roamingTotal} €</span></AdditionalExpensesRow>
							</ExpensesContainer>
						</Costs>
					</Indicator>
				</div>
			)}
		</Wrapper>
	);
};